import { useIsLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { useMilestone } from "@faire/retailer-visitor-shared/stores/domain/useMilestone";
import { useQuery as useShowSaleHubNudge } from "@faire/web-api--source/endpoints/www/api/retailer/show-deals-hub-nudge/get-hooks";
import { SALE_ANNOUNCEMENT_DISMISSED } from "@faire/web-api--source/indigofair/data/IUserMilestone/RetailerMilestone/SALE_ANNOUNCEMENT_DISMISSED";

export const useShouldShowSaleAnnouncementNudge = () => {
  const { hasOccurred: hasDismissedSaleAnnouncement } = useMilestone(
    SALE_ANNOUNCEMENT_DISMISSED
  );
  const isLoggedInRetailer = useIsLoggedInRetailer();
  const { data, isLoading } = useShowSaleHubNudge({
    enabled: isLoggedInRetailer,
  });
  const hasNotDismissedSaleAnnouncement =
    !hasDismissedSaleAnnouncement && !isLoading;
  const shouldShowNonPowerUserNudge =
    data?.should_show_nudge && hasNotDismissedSaleAnnouncement;
  const shouldShowPowerUserNudge =
    data?.should_show_flash_sales_power_user_nudge &&
    hasNotDismissedSaleAnnouncement;
  const shouldShowSalesHubNudge =
    shouldShowNonPowerUserNudge || shouldShowPowerUserNudge;

  return {
    shouldShowNonPowerUserNudge,
    shouldShowPowerUserNudge,
    shouldShowSalesHubNudge,
  };
};
